const MARKETING_EXACT = new Set(['/', '/produit', '/integrations', '/formation', '/contact']);

export const PUBLIC_INDEXABLE = new Set(['/privacy', '/terms', '/data-deletion']);

function stripTrailingSlash(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function isMarketingPath(pathname: string): boolean {
  const path = stripTrailingSlash(pathname);
  if (MARKETING_EXACT.has(path)) return true;
  return path.startsWith('/produit/');
}

export function isPublicIndexablePath(pathname: string): boolean {
  return PUBLIC_INDEXABLE.has(stripTrailingSlash(pathname));
}

export const FEATURE_SLUGS = [
  'confirmation',
  'commandes',
  'personnalisation',
  'livraison',
  'retours',
  'automatisations',
  'commissions',
  'pilotage',
] as const;

export type FeatureSlug = (typeof FEATURE_SLUGS)[number];

export function isFeatureSlug(value: string): value is FeatureSlug {
  return (FEATURE_SLUGS as readonly string[]).includes(value);
}
